import { useState, useEffect } from 'react';

const useGetScreenSize = () => {
	const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

	useEffect(() => {
		const handleResize = () => {
			setViewportHeight(window.innerHeight);
		};

		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return viewportHeight;
};

export default useGetScreenSize;
